import { c as _c } from "react/compiler-runtime";
import { SellerUnitsAndProjectsOne } from "@/types/sup";
import { toSentenceCase } from "@/utils/string/to-sentence-case";
interface FlooringProps {
  supOne: SellerUnitsAndProjectsOne;
}
export function Flooring(t0) {
  const $ = _c(8);
  const {
    supOne
  } = t0;
  let t1;
  if ($[0] !== supOne.spaceSummary?.flooring) {
    t1 = supOne.spaceSummary?.flooring || [];
    $[0] = supOne.spaceSummary?.flooring;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const flooring = t1;
  if (!flooring.length) {
    return null;
  }
  let t2;
  if ($[2] !== flooring) {
    let t3;
    if ($[4] !== flooring.length) {
      t3 = (item, index) => <div key={index} className="flex justify-between items-center gap-4 py-1.5 px-2 border-b border-gray-200"><span className="text-sm font-medium text-gray-600">{item.name}</span><div className="flex items-center gap-1"><span className="text-sm font-semibold text-right">{flooring.length === 1 ? "Everywhere" : (item.space || []).map(toSentenceCase).join(", ")}</span></div></div>;
      $[4] = flooring.length;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = flooring.map(t3);
    $[2] = flooring;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div>{t2}</div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}